var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import { AddProductText, StyledIconImage, StyledCard, PlusIcon } from "./styled/editPanel";
var plusIcon = "https://res.cloudinary.com/perkbox/image/upload/v1564587521/deals-light-ui/web/homepage/circlePlus.png";
var EditPanel = /** @class */ (function (_super) {
    __extends(EditPanel, _super);
    function EditPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditPanel.prototype.render = function () {
        var _a = this.props, createTile = _a.createTile, imageIcon = _a.imageIcon, title = _a.title, type = _a.type;
        return (React.createElement(StyledCard, { onClick: createTile.bind(null, type) },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 2 },
                    React.createElement(StyledIconImage, { src: imageIcon })),
                React.createElement(Col, { xs: 8 },
                    React.createElement(AddProductText, null,
                        React.createElement(FormattedMessage, { id: title }))),
                React.createElement(Col, { xs: 2 },
                    React.createElement(PlusIcon, { src: plusIcon })))));
    };
    return EditPanel;
}(Component));
export default EditPanel;
